<div class="admin-page-container">
  <app-smart-tabs [tabsConfig]="tabsConfig"></app-smart-tabs>
  <router-outlet></router-outlet>
</div>
